import { CellContext } from '@tanstack/react-table';

import { SessionDateCellContent } from 'features/participants/components/Table/SessionDateCellContent';
import {
  CoachingMode,
  ParticipantsTableUserInfo,
} from 'features/participants/config/types';
import { NextSessionAppointment } from 'features/sessions/config/types';
import { IDraftSprint, ISprint } from 'features/sprint/config/types';

type RowData = {
  userInfo: ParticipantsTableUserInfo;
  latestSprint: ISprint | IDraftSprint;
  coachingMode: CoachingMode;
};

export const SessionDateCell = ({
  row,
  getValue,
}: CellContext<RowData, NextSessionAppointment>) => {
  const nextSessionAppointment = getValue();

  return (
    <SessionDateCellContent
      userInfo={row.original.userInfo}
      attendance={nextSessionAppointment?.attendance}
      sessionId={nextSessionAppointment?.coachingSessionId}
      startAt={nextSessionAppointment?.startAt}
      latestSprint={row.original.latestSprint}
      coachingMode={row.original.coachingMode}
    />
  );
};
